import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { classNames } from 'primereact/utils';
import { FileUpload } from 'primereact/fileupload';
import { Panel } from 'primereact/panel';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import {
    Form,
    redirect,
    useLoaderData,
    useNavigate,
    useSubmit
} from "react-router-dom";
import { useFormik } from 'formik';
import { createService, getService, updateService, SERVICE_PAYMENT_FLOWS } from "../../../data/loca/services";
var base64data;

const customBase64Uploader = async (event) => {
    // convert file to base64 encoded
    const file = event.files[0];
    const reader = new FileReader();
    let blob = await fetch(file.objectURL).then((r) => r.blob()); 

    reader.readAsDataURL(blob);

    reader.onloadend = function () {
        base64data = reader.result;
    };
};

export async function action({ request, params }) {
    const formData = await request.formData();
    const data = Object.fromEntries(formData);
    const isAdminPlatformRoute = new URL(request.url).pathname.startsWith("/administration/plateformes");
 
    let id;
    if (params.serviceId)
        id = await updateService(data, params.serviceId);
    else
        id = await createService(data);

    return redirect(isAdminPlatformRoute ? `/administration/plateformes/${id}` : `/services/${id}`);
}
export async function loader({ params }) {
    const serv = await getService(params.serviceId);

    return { serv };
}
export default function AddService() {
    const { serv } = useLoaderData();
    const submit = useSubmit();
    let name, picture = "";
    let paymentFlow = "Direct";
    let commissionPercent = 0;
    let contractTerms = "";
    if (serv) {
        name = serv.value.name;
        picture = serv.value.base64Picture;
        paymentFlow = serv.value.paymentFlow || "Direct";
        commissionPercent = serv.value.commissionPercent ?? 0;
        contractTerms = serv.value.contractTerms ?? "";
    }
    // Formik ---------------------
    
    const formik = useFormik({
        initialValues: {
            name: name,
            picture: picture ?? '',
            paymentFlow: paymentFlow,
            commissionPercent: commissionPercent,
            contractTerms: contractTerms,
        },
        validate: (data) => {
            let errors = {};

            if (!data.name) {
                errors.name = 'name is required.';
            }
            if (data.commissionPercent != null && (data.commissionPercent < 0 || data.commissionPercent > 100)) {
                errors.commissionPercent = 'La commission doit être comprise entre 0 et 100 %.';
            }

            return errors;
        },
        onSubmit: async (data) => {
            if (base64data)
                data.picture = base64data;
            submit(data, { method: "post" })
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    //----------------------------------------
  
    const navigate = useNavigate();
    return (
        <div>
            <h1>{(serv) ? "Modification" : "Ajout"} d'une plateforme</h1>
            <Form method="post" id="thumbnail-form" onSubmit={formik.handleSubmit}>
                <Panel header="Veuillez renseigner le nom de la plateforme :">

                    <div className="contentForm">
                        <span className="p-float-label">
                    <InputText id="name" name="name" value={formik.values.name}
                        onChange={(e) => {
                            formik.setFieldValue('name', e.target.value);
                        }}
                        className={classNames({ 'p-invalid': isFormFieldInvalid('name') })}
                        />
                            <label htmlFor="name">Nom</label>
                        </span>
                    </div>
                    <div className="contentForm"></div >
                </Panel>
                <div className="contentForm"></div >
                <Panel header="Comment le locataire paie-t-il ?">
                    <p className="platform-flow-intro">Ce choix fixe les &eacute;tapes de suivi des nouvelles locations de cette plateforme. Les &eacute;tapes communes (contrat, signature, caution et sa lib&eacute;ration) ne changent pas.</p>
                    <div className="platform-flow-options">
                        {SERVICE_PAYMENT_FLOWS.map((flow) => (
                            <label key={flow.value} htmlFor={`payment-flow-${flow.value}`} className={classNames("platform-flow-option", { "platform-flow-option--selected": formik.values.paymentFlow === flow.value })}>
                                <RadioButton inputId={`payment-flow-${flow.value}`} name="paymentFlow" value={flow.value} onChange={(e) => formik.setFieldValue("paymentFlow", e.value)} checked={formik.values.paymentFlow === flow.value} />
                                <span>
                                    <b>{flow.label}</b>
                                    <small>{flow.description}</small>
                                    <span className="platform-flow-steps">
                                        {flow.steps.map((step) => (
                                            <span key={step}><i className="pi pi-check-circle"></i>{step}</span>
                                        ))}
                                    </span>
                                </span>
                            </label>
                        ))}
                    </div>
                </Panel>
                <div className="contentForm"></div >
                <Panel header="Commission et contrat">
                    <div className="platform-settings-grid">
                        <div className="platform-settings-field">
                            <label htmlFor="commissionPercent">Commission de la plateforme</label>
                            <InputNumber inputId="commissionPercent" value={formik.values.commissionPercent}
                                onValueChange={(e) => formik.setFieldValue("commissionPercent", e.value ?? 0)}
                                suffix=" %" locale="fr-FR" minFractionDigits={0} maxFractionDigits={2} min={0} max={100}
                                className={classNames({ 'p-invalid': !!formik.errors.commissionPercent })} />
                            <small>Pourcentage du montant de la location retenu par la plateforme, compté dans les frais de la location (statistiques). 0 si la plateforme ne prend rien au loueur.</small>
                        </div>
                        <div className="platform-settings-field platform-settings-field--wide">
                            <span className="platform-settings-label-row">
                                <label htmlFor="contractTerms">Article 3bis du contrat</label>
                                <Button type="button" size="small" text icon="pi pi-file-edit" label="Texte type"
                                    disabled={!SERVICE_PAYMENT_FLOWS.find((flow) => flow.value === formik.values.paymentFlow)?.contractTerms}
                                    onClick={() => formik.setFieldValue("contractTerms", SERVICE_PAYMENT_FLOWS.find((flow) => flow.value === formik.values.paymentFlow)?.contractTerms ?? "")} />
                            </span>
                            <InputTextarea id="contractTerms" value={formik.values.contractTerms} rows={4} autoResize
                                onChange={(e) => formik.setFieldValue("contractTerms", e.target.value)} />
                            <small>Ins&eacute;r&eacute; dans le contrat des locations de cette plateforme (variable <code>{"{{serviceTerms}}"}</code>). Variables : <code>{"{{serviceName}}"}</code> (nom de la plateforme) et <code>{"{{lessorDative}}"}</code> (&laquo; au loueur &raquo; ou &laquo; au propri&eacute;taire &raquo;). Laisser vide pour ne pas ajouter d'article.</small>
                        </div>
                    </div>
                </Panel>
                <div className="contentForm"></div >
                <div className="card">
                    <FileUpload name="picture[]" accept="image/*" maxFileSize={1000000} auto uploadHandler={customBase64Uploader} customUpload emptyTemplate={<p className="m-0">D&eacute;posez le logo ici</p>} chooseLabel="Choisir..." />
                </div>
           
               
            <p>
                <Button type="submit" size="small">Enregistrer</Button>
                <Button type="button"
                    size="small"
                    severity="secondary"
                    onClick={() => {
                        navigate(-1);
                    }}>Annuler</Button>
            </p>
            </Form>
            </div>
    );
}
